import { useEffect, useState } from 'react'

/**
 * Zero-dependency path router. Three routes don't justify TanStack — we parse
 * `location.pathname` and re-render on popstate. `navigate()` pushes history
 * and fires a synthetic popstate so every `usePath()` subscriber updates.
 */
export function navigate(to: string, opts?: { replace?: boolean }): void {
  if (opts?.replace) window.history.replaceState(null, '', to)
  else window.history.pushState(null, '', to)
  window.dispatchEvent(new PopStateEvent('popstate'))
}

export function usePath(): string {
  const [path, setPath] = useState(() => window.location.pathname)
  useEffect(() => {
    const onPop = () => setPath(window.location.pathname)
    window.addEventListener('popstate', onPop)
    return () => window.removeEventListener('popstate', onPop)
  }, [])
  return path
}
